import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './testing/reportWebVitals';
import * as serviceWorkerRegistration from './testing/serviceWorkerRegistration';
import { saveSearchParams } from './util/util';

saveSearchParams();

// Overriding alert as console log
window.alert = function (message) {
    console.error('Alert disabled:', message);
};

// Function to hide the address bar
function hideAddressBar() {
    if (window.innerHeight > window.innerWidth) {
        // Portrait mode
        window.scrollTo(0, 1);
    } else {
        // Landscape mode
        window.scrollTo(1, 0);
    }
    console.log('hideAddressBar');
}

// Hide address bar when the page is loaded
window.addEventListener('load', function () {
    setTimeout(hideAddressBar, 0);
});

// Hide address bar on orientation change
window.addEventListener('orientationchange', hideAddressBar);
hideAddressBar();

// Catch unhandled errors globally and log them
window.onerror = function (message, source, lineno, colno, error) {
    console.error('Global Error Caught:', message, error);
    return true; // Suppresses the default browser error handling (alert)
};

// Catch unhandled promise rejections globally
window.onunhandledrejection = function (event) {
    console.error('Unhandled Rejection Caught:', event.reason);
    event.preventDefault(); // Suppresses the React error pop-up
};

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <div className="App">
            <div className="unity-container">
                <App />
            </div>
        </div>
    </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
